<template>
  <base-dialog-full
                      :show="true"
                      :tempSaveBtn="false"
                      title="選擇保險公司"
                      @close="baseDialogCloseHandler"
                      >
      <div class="title-name">選擇保險公司</div>
      <v-item-group mandatory>
        <v-container grid-list-md>
            <v-layout wrap
                      justify-center
                      style="margin: 5px;">
              <v-flex md4 v-for="(item,index) in proCompanyList"
                          :key="index">
                <v-item>
                  <v-card slot-scope="{ toggle }"
                          class="align-center justify-center d-flex"
                          :style="(isActive(item.compCode))?'background-color: #fff;border: 2px solid #fff;':'pointer-events:none;background-color: #cecece;'"
                          height="145"
                          @click="toggle"
                          @click.native="cardComClickHandler(item.compCode)"
                          >
                    <div class="item-group-title">{{ item.compName }}</div>
                  </v-card>
                </v-item>
              </v-flex>
            </v-layout>
          </v-container>
      </v-item-group>
  </base-dialog-full>
</template>
<script>
import {
  filter
} from 'lodash'
export default {
  name: 'select-company',
  props: {
    items: Array
  },
  data () {
    return {
      proCompanyList: [],
      activeCH: false
    }
  },
  computed: {
  },
  created () {
    let vm = this
    vm.startLoading()
    let featchItems = function () {
      if (vm.items != null && vm.items.length > 0) {
        vm.items.forEach(e => {
          vm.proCompanyList.push(e)
        })
      } else {
      // PRO_COMP-S01(保險公司服務)
        vm.$api
          .get('/pro/proCompanyies', {
            params: {
              queryString: ''
            }
          })
          .then(r => {
            vm.proCompanyList = r.data
          })
      }
    }
    vm.$api.get('/adm/com/parmd', { params: {} })
      .then(r => {
        const paramCH = filter(r.data, {
          parameterType: 'ADM',
          parameterCode: 'CH_OPEN_YN'
        })
        if (paramCH && paramCH.length > 0 && paramCH[0].parameterValue === 'Y') {
          vm.activeCH = true
        } else {
          vm.activeCH = false
        }
        featchItems()
        vm.endLoading()
      }).catch(() => {
        vm.endLoading()
      })
  },
  methods: {
    startLoading () {
      this.$store.commit('START')
    },
    endLoading () {
      this.$store.commit('END')
    },
    isActive (compCode) {
      if (compCode === 'BPC') {
        return false
      }
      if (compCode === 'CH') {
        return this.activeCH
      }
      return true
    },
    cardComClickHandler (code) {
      this.$emit('click', code)
    },
    baseDialogCloseHandler () {
      this.$confirm('是否確認離開此要保書建置？').then(yn => {
        if (yn) {
          this.$emit('close')
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.v-stepper__content {
  padding: 0px;
}

s, .bg-default {
  background-color: #fff;
  padding: 10px;
  margin: 30px 0 30px;
}

.title-name {
  font-size: $font-size-ml;
  font-weight: bold;
  letter-spacing: 1.2px;
  margin-top: 30px;
  text-align: left;
}

.border-active {
  border-color: $accent-color !important;
  border-radius: 5px;
}

.item-group-title {
  font-size: $font-size-lg;
  font-weight: bolder;
  color: $accent-color;
}
</style>
